import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import $ from 'dom7';
import Utils from '../../utils/utils';
import Modal from '../modal/modal-class';

var LoginScreen =
/*#__PURE__*/
function (_Modal) {
  _inherits(LoginScreen, _Modal);

  function LoginScreen(app, params) {
    var _this;

    _classCallCheck(this, LoginScreen);

    var extendedParams = Utils.extend({
      on: {}
    }, params); // Extends with open/close Modal methods;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginScreen).call(this, app, extendedParams));

    var loginScreen = _assertThisInitialized(_assertThisInitialized(_this));

    loginScreen.params = extendedParams; // Find Element

    var $el;

    if (!loginScreen.params.el) {
      $el = $(loginScreen.params.content).filter(function (elIndex, node) {
        return node.nodeType === 1;
      }).eq(0);
    } else {
      $el = $(loginScreen.params.el).eq(0);
    }

    if ($el && $el.length > 0 && $el[0].f7Modal) {
      return _possibleConstructorReturn(_this, $el[0].f7Modal);
    }

    if ($el.length === 0) {
      return _possibleConstructorReturn(_this, loginScreen.destroy());
    }

    Utils.extend(loginScreen, {
      app: app,
      $el: $el,
      el: $el[0],
      type: 'loginScreen'
    });
    $el[0].f7Modal = loginScreen;
    return _possibleConstructorReturn(_this, loginScreen);
  }

  return LoginScreen;
}(Modal);

export default LoginScreen;